

















































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

@Component({
  components: {
    Loading,
  },
})
export default class App extends Vue {
  timeout!: NodeJS.Timeout;
 /* @Watch("isAppIdle")
  onAppIdle(idle: boolean): void {
    if (idle && !this.isLogin) {
      this.$modal.show("idle");
      this.timeout = setTimeout(() => {
        this.logout();
      }, 30000);
    }
  }*/
 @Watch("isAppIdle")
  onAppIdle(idle: boolean): void {
    if (idle && !this.isLogin) {
      const requiresAuth = this.$route.meta?.auth;
      if (requiresAuth) {
        this.$modal.show("idle");
        this.timeout = setTimeout(() => {
          this.logout();
        }, 30000);
      }
    }
  }

  cancelTimeout(): void {
    clearTimeout(this.timeout);
    this.$modal.hide("idle");
  }
  logout(): void {
    this.$store.dispatch("auth/logout");
    this.$modal.hide("idle");
    this.$router.push({ name: "login" });
  }
  get isLogin(): boolean {
    return this.$route.name === "login";
  }
  created() {
    this.$http.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (err.response.status === 401) {
          this.$store.dispatch("logout");
          this.$router.push({ name: "login" });
        }
        throw err;
      });
    });
  }
}
